import { Link, LinkProps } from 'react-router-dom'

interface LinkRouteProps extends LinkProps {
  external?: boolean
}

const LinkRoute = (props: LinkRouteProps) => {

  const {external = false, ...rest} = props || {}

  return external ? <a href={props?.to?.toString() || '/'} {...rest}>{props.children}</a> : <Link {...rest} />
}

export default LinkRoute